import Vue from 'vue';
import Vuetify from 'vuetify';
import fr from 'vuetify/src/locale/fr';
import colors from 'vuetify/lib/util/colors';
Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        options: {
            customProperties: true,
        },
        themes: {
            light: {
                primary: colors.deepPurple.darken3,
                secondary: colors.orange.accent4,
                error: '#ff5252',
                info: '#3399ff',
                success: '#35c940',
                warning: '#f83367',
                snackBarValid: '#6d98d5',
                snackBarError: '#d77e75',
            },
        },
    },
    lang: {
        locales: {fr},
        current: 'fr',
    },
});
